module.exports = __webpack_public_path__ + "img/logo-ps-combined.7069a89c.svg";